Shopify.Collapse = function () {
    let collapse_true = document.querySelector('.collapse_true') ? document.querySelector('.collapse_true') : [];
  
    let titleCollapse = document.querySelectorAll('.collapse_true .widget-title');
    
    if(titleCollapse && titleCollapse.length){
        titleCollapse.forEach(trigger => {
        trigger.addEventListener('click', toggle);
      });
    }
    
    function toggle(evt){
      let el = evt.currentTarget;
      let widget = el.parentNode;

      let isOpen = widget.classList.contains('widget_opened');
      let content = widget.querySelector('.widget_content');
  
      if (isOpen) {
        content.style.height = "0px";
        content.addEventListener('transitionend', function() {widget.classList.remove('widget_opened')}, {once: true});

      } else {
    
        widget.classList.add('widget_opened');
        content.style.height = "auto";
       var height = content.clientHeight + "px";
        content.style.height = "0px";
    setTimeout(() => { content.style.height = height; }, 0) 
      }
    }
  };
  
  Shopify.Collapse();